// components/ProtectedRoute.tsx
// Requires an authenticated session with accountType === 'admin' custom claim.

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { currentUser, claims } = useAuth();

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // Access requires accountType === 'admin' in custom claims.
    // Claims are null if the backend onAuthCreate CF hasn't run yet or hasn't granted admin.
    if (!claims || claims.accountType !== 'admin') {
        return (
            <div style={{ padding: '40px', textAlign: 'center' }}>
                <h2>Access Denied</h2>
                <p>Your account does not have admin access to this panel.</p>
                <p style={{ color: '#888', fontSize: '14px' }}>
                    Contact a super admin to have the <code>admin</code> role granted to your account.
                </p>
                <button onClick={() => window.location.href = '/login'}>
                    Back to Login
                </button>
            </div>
        );
    }

    return <>{children}</>;
};
